/**
 * ╔═══════════════════════════════════════════════════════════════════════════╗
 * ║                         BRAND CONFIGURATION                              ║
 * ║           Change these values when forking for a new creator             ║
 * ╠═══════════════════════════════════════════════════════════════════════════╣
 * ║                                                                           ║
 * ║  This is the SINGLE SOURCE OF TRUTH for all brand-specific values        ║
 * ║  in the fan-facing frontend. When forking for a new creator/company,     ║
 * ║  change the values here. index.html must also be updated manually.       ║
 * ║                                                                           ║
 * ╚═══════════════════════════════════════════════════════════════════════════╝
 */

// ============================================================================
// CREATOR IDENTITY
// ============================================================================

/** Creator's display name */
export const CREATOR_NAME = 'Mini'

/** Brand name (used in titles, headers) */
export const BRAND_NAME = 'minicaryn'

/** Site domain (without protocol) */
export const SITE_DOMAIN = 'minicaryn.com'

/** Community/fan group name */
export const COMMUNITY_NAME = "Mini's World"

/** Product/world name */
export const PRODUCT_NAME = "Mini's World"

/** Creator's initials (used in signatures) */
export const CREATOR_INITIALS = 'mc'

// ============================================================================
// CONTACT & SOCIAL
// ============================================================================

/** Primary support email */
export const SUPPORT_EMAIL = 'mincaryn@fansupportdesk.com'

/** Twitter/X handle */
export const TWITTER_HANDLE = 'minicaryn'

/** Twitter/X URL */
export const TWITTER_URL = 'https://twitter.com/minicaryn'

// ============================================================================
// PAGE COPY
// ============================================================================

/** Login page header */
export const LOGIN_TITLE = 'minicaryn'

/** Login page subtitle */
export const LOGIN_SUBTITLE = 'invite only community'

/** Apply page header */
export const APPLY_TITLE = 'minicaryn'

/** Apply page subtitle */
export const APPLY_SUBTITLE = 'Membership Application'

/** Community membership question */
export const COMMUNITY_QUESTION = `Are you an active ${COMMUNITY_NAME} member?`

/** Application confirmation message */
export const CONFIRMATION_MESSAGE = `You're now in line to join ${PRODUCT_NAME}. Please be patient while your application is reviewed. If you'd like it reviewed sooner, you can choose to expedite your application.`

/** Chat bot persona name */
export const CHAT_BOT_NAME = 'Mini'

// ============================================================================
// WELCOME MESSAGES
// ============================================================================

/** Welcome back message for returning users */
export const WELCOME_BACK_MESSAGE = `welcome to ${SITE_DOMAIN} \u{1F497}

this is basically my little corner of the internet :)

if you're here, you were invited on purpose\u{2026} so you matter to me a lot.

i wanted a space that actually feels like me, where everything's in one place without all the extra noise. i'm gonna be way more active on here, and eventually this might be the only place you can really find me.

thanks for being here and riding this out with me. it means more than you think.

enjoy\u{1FAF6}`

/** Post-payment welcome message */
export const POST_PAYMENT_WELCOME_MESSAGE = `welcome to ${SITE_DOMAIN} \u{1F497}

this is basically my little corner of the internet :)

if you're here, you were invited on purpose\u{2026} so you matter to me a lot.

i wanted a space that actually feels like me, where everything's in one place without all the extra noise. i'm gonna be way more active on here, and eventually this might be the only place you can really find me.

thanks for being here and riding this out with me. it means more than you think.

enjoy\u{1FAF6}`

/** Welcome message signature */
export const WELCOME_SIGNATURE = CREATOR_INITIALS

// ============================================================================
// BRAND COLORS (for chat widget and inline styles)
// ============================================================================

export const BRAND_COLORS = {
  primary: '#87CEEB',         // sky-blue
  primaryDark: '#6CB4D9',     // medium-sky
  primaryDarker: '#4AA3CC',   // deep-sky
  backgroundLight: '#D4EEFF', // cloud-blue
  backgroundAccent: '#F0F8FF', // lightest-sky
  inputBorder: '#87CEEB',     // sky-blue
  themeColor: '#87CEEB',      // sky-blue (meta theme-color)
}
